import React from "react";
import { object, array } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import Organism2 from "../../organisms/organism-2";
import DfpAd from "../../dfp-ad";

import "./sixteen-stories-sixteen-images.m.css";
import { getSlug } from "../../utils";

const SixteenStoriesSixteenImages = ({ collection, sections }) => {
  const collectionItems = collection.items ? collection.items : [];
  const filteredCollectionItems = collectionItems.filter(item => item.type === "collection").slice(0, 4);

  const organism2Set = filteredCollectionItems.map((item, index) => {
    const totalItems = item.items.length;
    const childCollection = item.items ? item.items : [];
    const collectionName = item.name;
    const slug = getSlug(item, sections);
    const collectionStories = childCollection.filter(item => item.type === "story").slice(0, 4);
    const collectionOfCollections = childCollection.filter(item => item.type === "collection").slice(0, 3);

    return (
      <Organism2
        collectionStories={collectionStories}
        collectionOfCollections={collectionOfCollections}
        collection={item}
        key={index}
        collectionName={collectionName}
        limit={3}
        headerType={14}
        headlineLimit={75}
        totalItems={totalItems}
        href={slug}
      />
    );
  });

  return filteredCollectionItems ? (
    <React.Fragment>
      <div styleName="wrapper">{organism2Set}</div>
      <div styleName="dfp-ad-728x90">
        <DfpAd adtype="leaderboard_2_728x90" />
      </div>
    </React.Fragment>
  ) : null;
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

export default connect(
  mapStateToProps,
  null
)(SixteenStoriesSixteenImages);

SixteenStoriesSixteenImages.propTypes = {
  collection: object,
  sections: array
};
